module.exports = __webpack_public_path__ + "static/media/1023500.3317b00e.png";